import { render, staticRenderFns } from "./card-article.vue?vue&type=template&id=570c51e6"
import script from "./card-article.vue?vue&type=script&lang=js"
export * from "./card-article.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports